"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _BaseButton = require("./BaseButton");
var _lodash = require("lodash");
var _excluded = ["type", "size", "underline", "className", "children", "icon", "iconPosition", "iconSize", "iconClassName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var buttonStyles = function buttonStyles(params) {
  var type = params.type,
    size = params.size,
    icon = params.icon,
    underline = params.underline;
  return (0, _classnames.default)('btn-text', {
    'tw-body-sm-medium': size === 'small'
  }, {
    'tw-label-medium': size === 'large'
  }, {
    'btn-text-light': type === 'light'
  }, {
    'btn-text-light-noicon': type === 'light' && !icon && underline
  }, {
    'btn-text-banner': type === 'banner'
  }, {
    'btn-text-banner-noicon': type === 'banner' && !icon && underline
  }, {
    'btn-text-dark': !type
  }, {
    'btn-text-dark-noicon': !type && !icon && underline
  });
};
var iconStyles = function iconStyles(buttonSize) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
  var iconSize = arguments.length > 2 ? arguments[2] : undefined;
  var className = arguments.length > 3 ? arguments[3] : undefined;
  return buttonSize === 'large' ? (0, _classnames.default)(iconSize || 'h-[24px] w-[24px]', {
    'ml-[8px]': position === 'right'
  }, {
    'mr-[8px]': position === 'left'
  }, className) : (0, _classnames.default)(iconSize || 'h-[16px] w-[16px]', {
    'ml-[4px]': position === 'right'
  }, {
    'mr-[4px]': position === 'left'
  }, className);
};
var Icon = function Icon(props) {
  var icon = props.icon,
    size = props.size,
    position = props.position,
    buttonSize = props.buttonSize,
    className = props.className;
  if (!icon) {
    return null;
  }
  var iconClassName = iconStyles(buttonSize, position, _Icon.IconSizeStyles[size], className);
  if ((0, _lodash.isString)(icon)) {
    return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      type: icon,
      className: iconClassName,
      "aria-hidden": true
    });
  }
  if ((0, _lodash.isFunction)(icon)) {
    return icon({
      className: iconClassName
    });
  }
  return icon;
};
var TextButton = function TextButton(props) {
  var type = props.type,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    _props$underline = props.underline,
    underline = _props$underline === void 0 ? true : _props$underline,
    className = props.className,
    children = props.children,
    icon = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'right' : _props$iconPosition,
    iconSize = props.iconSize,
    iconClassName = props.iconClassName,
    restProps = _objectWithoutProperties(props, _excluded);
  var styles = buttonStyles({
    type: type,
    size: size,
    icon: !!icon,
    underline: underline
  });
  var iconElement = icon && /*#__PURE__*/_react.default.createElement(Icon, {
    buttonSize: size,
    icon: icon,
    position: iconPosition,
    size: iconSize,
    className: iconClassName
  });
  return /*#__PURE__*/_react.default.createElement(_BaseButton.BaseButton, _extends({
    className: (0, _classnames.default)(styles, className)
  }, restProps), /*#__PURE__*/_react.default.createElement("span", {
    className: "flex items-center"
  }, icon && iconPosition === 'left' && iconElement, /*#__PURE__*/_react.default.createElement("span", null, children), icon && iconPosition === 'right' && iconElement));
};
exports.TextButton = TextButton;